import React from 'react'

const SearchInputNosto = ({
    value,
    onChange,
    onSearch,
    onInput,
    suggestions = [],
    onSuggestionClick,
    placeholder = 'Search',
    className = '',
    onClick,
    ref,
}) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()

            // Record attribution for search submission
            if (typeof window !== 'undefined' && window.nostojs && value && value.trim()) {
                window.nostojs((api) => {
                    api.recordAttribution({
                        type: 'is', // Internal Search
                        target: value.trim(),
                        ref: 'search-input'
                    })
                        .done()
                        .then((data) => {
                            // Attribution recorded successfully
                        })
                        .catch((error) => {
                            console.error('Nosto search submission attribution error:', error);
                        });
                });
            }

            onSearch()
        }
    }

    return (
        <div className="search-container relative w-full">
            <input
                type="text"
                id="searchInput"
                placeholder={value ? '' : placeholder}
                className={`search-input items-center h-16 bg-[#EFEFEF] rounded-sm border-1 border px-2 hover:cursor-pointer hover:border-blue-400 hover:border-2 text-ash ${className}`}
                value={value}
                onChange={(e) => {
                    onChange(e.target.value)
                    if (onInput) onInput(e.target.value)
                }}
                onKeyDown={handleKeyDown}
                onClick={onClick}
                autoComplete="off"
                ref={ref}
            />
            {suggestions.length > 0 && (
                <ul className="absolute top-full left-0 w-full bg-white border border-oat mt-1 rounded shadow-lg z-10 max-h-52 overflow-y-auto">
                    {suggestions.map((s, i) => (
                        <li
                            key={i}
                            className="p-2 hover:bg-[#EFEFEF] cursor-pointer text-black"
                            onClick={() => {
                                // Record attribution for suggestion click
                                if (typeof window !== 'undefined' && window.nostojs) {
                                    window.nostojs((api) => {
                                        api.recordAttribution({
                                            type: 'is', // Internal Search
                                            target: s,
                                            ref: 'search-input-suggestions'
                                        })
                                                                        .done()
                            .then((data) => {
                                // Attribution recorded successfully
                            })
                            .catch((error) => {
                                console.error('Nosto search input suggestion attribution error:', error);
                            });
                                    });
                                }
                                onSuggestionClick(s)
                            }}
                        >
                            {s}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default SearchInputNosto
